// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_9e1425b4d3--spinner--YYHWw","circle-spin":"_9e1425b4d3--circle-spin--Sbn3c"};